
export function createAction(type, payload=null) {
  return {
    type,
    payload,
  };
}